import { IconProps } from "./";
import Icon from "./assets/ellipse_4.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon4Pointer(props: IconProps) {
  return <BaseIcon className="text-xs" icon={<Icon />} {...props} />;
}
